import UIApplication from 'UIComponents/app/UIApplication';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Text } from 'foundations-components/components/Text';
// @ts-ignore untyped loader
import { name as packageName } from 'current-package-loader!';
import { renderAppRoot } from './root-renderer';
import { jsx as _jsx } from "react/jsx-runtime";
function VpnRequiredErrorPage() {
  return /*#__PURE__*/_jsx(UIApplication, {
    name: packageName,
    children: /*#__PURE__*/_jsx(ErrorMessage, {
      title: "VPN connection required",
      type: "403",
      children: /*#__PURE__*/_jsx(Text, {
        children: "This app is only accessible on the HubSpot VPN. Connect to the VPN and refresh the page to continue."
      })
    })
  });
}
export function renderVpnRequiredErrorPage({
  container,
  legacyRoot,
  strictMode
}) {
  return renderAppRoot( /*#__PURE__*/_jsx(VpnRequiredErrorPage, {}), {
    container,
    legacyRoot,
    strictMode
  });
}